import React from "react";

const Hero = () => {
  return (
    <section className="text-center mb-20">
      <h2 className="text-5xl font-extrabold mb-6 text-gray-900">
        Design Your Perfect Skadisfinity Layout
      </h2>
      <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
        Effortlessly create custom Skadisfinity layouts tailored to your
        workspace with our intuitive calculator.
      </p>
    </section>
  );
};

export default Hero;
